@use '../../styling/typography.scss' as *;
@use '../../styling/colors.scss' as *;

@keyframes grow {
  from {
    transform: scale(0);
  }

  to {
    transform: scale(1);
  }
}

.SuccessMessage {
  @extend %font-family-primary;

  padding: 40px;
  border-radius: 6px;
  background: $theme-color-background;
  word-break: break-word;

  &.hasFixWidth {
    min-width: 370px;
    max-width: 370px;
    justify-self: center;
  }

  svg {
    display: block;
    margin: 0 auto;
    animation-duration: 0.25s;
    animation-name: grow;
    animation-timing-function: ease-in;

    path {
      fill: $color-secondary-green;
    }
  }

  strong {
    text-align: center;
    display: block;
    font-weight: $font-weight-semibold;
    color: $theme-color-text;
    font-size: 16px;
    margin-top: 12px;
  }
}
